import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeaders() {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
}

/**
 * Absolute URL to a stored experience photo, safe to drop into an
 * <img src=... />. The backend serves the file over `/api/experiences/
 * photo/{path:path}` — the path may contain slashes, but the FastAPI
 * `{path:path}` matcher accepts them so we don't url-encode them.
 */
export function experiencePhotoUrl(path) {
  if (!path) return '';
  return `${API}/experiences/photo/${path}`;
}

export async function fetchAdminExperiences(status = '') {
  const params = status ? { status } : {};
  const { data } = await axios.get(`${API}/admin/experiences`, {
    params,
    headers: authHeaders(),
  });
  return Array.isArray(data) ? data : [];
}

export async function approveAdminExperience(id, tier = 'regular') {
  const { data } = await axios.post(
    `${API}/admin/experiences/${id}/approve`,
    { tier },
    { headers: authHeaders() },
  );
  return data;
}

export async function declineAdminExperience(id, reason = '') {
  const { data } = await axios.post(
    `${API}/admin/experiences/${id}/decline`,
    { reason },
    { headers: authHeaders() },
  );
  return data;
}

export async function updateAdminExperience(id, patch) {
  // patch: { description?: string, tier?: 'regular'|'premium' }
  const { data } = await axios.patch(
    `${API}/admin/experiences/${id}`,
    patch,
    { headers: authHeaders() },
  );
  return data;
}

export async function deleteAdminExperience(id) {
  const { data } = await axios.delete(`${API}/experiences/${id}`, {
    headers: authHeaders(),
  });
  return data;
}
